module.exports = __webpack_public_path__ + "img/right_logo.3dbf2065.svg";